import _ from 'lodash'
import React, { useState, useEffect } from 'react'
import { ListingPreviewBody } from '@vzmi/shp_shared_compo'
import { getAttrTransientKey } from '../Common/ProposalForm/Shared/util'
import { getFormData } from '../ProductListingBaseForm/helpers/getters'
import { SilentPageProvider } from '../../../context/silentPageContext'
import Header from '../../../components/Common/Header'
import { withI13nWrapper } from '../../Common/I13nWrapper'

export const extractDeliveryInfo = proposal => {
  const shipType = _.get(proposal, 'product.shipType.id')
  const deliveryInfoKey = `shipTypeFormSection.shipType${shipType}`
  const deliveryType = _.get(proposal, `${deliveryInfoKey}.listing.deliveryType`)
  return {
    shipType,
    deliveryInfoKey,
    deliveryType
  }
}

export const extractSpecsAndImages = proposal => {
  const { product = {}, subStationId } = proposal
  const { catItemId, struDataAttrClusterId } = product
  const attrTransientKey = getAttrTransientKey(
    subStationId,
    catItemId,
    struDataAttrClusterId
  )
  const { spec: specWrappers = [], table, hasSpecLevel } = _.get(
    proposal,
    attrTransientKey,
    {}
  )
  const models = _.get(
    table,
    `with${hasSpecLevel ? '' : 'out'}Level.models`,
    []
  )
  return {
    specs: specWrappers.map((wrapper = {}) => {
      const { name, selectedItemOptions = [] } = wrapper
      const options = selectedItemOptions.map(opt => _.get(opt, 'displayName'))
      return {
        name,
        options
      }
    }),
    images: models.map((model = {}) => {
      const { images = [] } = model
      return images.map(image => image.url)
    })
  }
}

export const extractAttributes = proposal => {
  const { subStationId, product = {} } = proposal
  const { catItemId, struDataAttrClusterId } = product
  const attrTransientKey = getAttrTransientKey(
    subStationId,
    catItemId,
    struDataAttrClusterId
  )
  const { spec = [], attributes: attrsWrapper, hasSpecLevel } = _.get(
    proposal,
    attrTransientKey,
    {}
  )
  const pickedSpecs = [...spec]
  // 填寫的規格
  const filledAttributes = [
    ..._.get(attrsWrapper, `with${hasSpecLevel ? '' : 'out'}Level`, [])
  ]
  // 設定的規格
  const struDataAttributes = _.get(
    proposal,
    'setting.struDataAttrCluster.attributes',
    []
  )
  const result = []
  // 1. 依設定的規格依序取得值
  _.each(struDataAttributes, (struDataAttr = {}) => {
    const { name } = struDataAttr
    let foundAttr = _.remove(filledAttributes, { name })[0]
    if (foundAttr) {
      const { values = [] } = foundAttr
      // 非必填未填不顯示
      !_.isEmpty(values) && result.push({ name, values: foundAttr.values })
      return
    }
    // 未在填寫的規格中找到，可能被選為屬性
    foundAttr = _.remove(pickedSpecs, { name })[0]
    if (foundAttr) {
      result.push({
        name,
        values: _.map(
          _.get(foundAttr, 'selectedItemOptions', []),
          opt => opt.displayName
        )
      })
    }
  })
  // 2. 新增的自訂規格
  result.push(
    ..._.map(filledAttributes, ({ name, values }) => ({ name, values }))
  )
  // 3. 新增的自訂屬性規格
  result.push(
    ..._.map(pickedSpecs, ({ name, selectedItemOptions: opts = [] }) => ({
      name,
      values: _.map(opts, opt => opt.displayName)
    }))
  )
  return result
}

const useProposal = props => {
  const [proposal, setProposal] = useState()
  useEffect(() => {
    getFormData(props).then((res = {}) => {
      const { listing, product } = res
      const warranty = _.get(product, 'warranty', {})
      const video = _.get(product, 'models[0].videos[0].url')
      const { deliveryInfoKey, deliveryType, shipType } = extractDeliveryInfo(
        res
      )
      const { specs, images } = extractSpecsAndImages(res)
      const sanitizedProposal = {
        listing: {
          ..._.pick(listing, ['featureTitle', 'price']),
          deliveryType,
          preOrderExpectedShipDate: _.get(
            res,
            `${deliveryInfoKey}.listing.preOrderExpectedShipDate`
          ),
          customizedOrderShipDateAfterPlaced: _.get(
            res,
            `${deliveryInfoKey}.listing.customizedOrderShipDateAfterPlaced`
          )
        },
        product: {
          ..._.pick(product, [
            'attributeDisplayMode',
            'contentRating',
            'gameContents',
            'copy',
            'name',
            'shortDescription'
          ]),
          warranty: {
            ...warranty,
            scope: warranty.custom_scope || warranty.scope
          },
          isExpiringItem: _.get(res, `${deliveryInfoKey}.product.isExpiringItem`),
          shipType,
          specs,
          images
        }
      }

      if (video) {
        sanitizedProposal.product.videos = [video]
      }

      sanitizedProposal.product.attributes = extractAttributes(res)

      setProposal(sanitizedProposal)
    })
  }, [])
  return proposal
}

const Footer = props => null

const ListingPreview = props => {
  const { supplier, page, actions, isHideNavigation = true } = props
  const proposal = useProposal(props)
  return (
    <div>
      <SilentPageProvider defaultValue>
        <Header
          key='header'
          supplier={supplier}
          page={page}
          actions={actions}
          isHideNavigation={isHideNavigation}
        />
      </SilentPageProvider>
      <ListingPreviewBody
        key='body'
        proposal={proposal}
      />
      <Footer key='footer' />
    </div>
  )
}

export default withI13nWrapper(ListingPreview)
